// extracted by mini-css-extract-plugin
export var separatorLine = "SeparatorBar-module__separatorLine___iVL1W";